var _excluded = ["desc", "focusable", "title", "iconName", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { string, bool } from 'prop-types';
import classNames from 'classnames';
var svg = /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.153 10.706c.066.707.526 1.01 2.131 1.315 2.283.392 3.378 1.479 3.561 3.45a3.659 3.659 0 01-2.222 3.749 4.378 4.378 0 01.452 1.62c.211 2.27-1.464 4.004-4.205 4.258a5.9 5.9 0 01-3.684-.586l-.222-2.4.324-.223a4.686 4.686 0 003.14.766c1.262-.117 1.904-.653 1.834-1.401-.063-.686-.526-1.01-2.13-1.315-2.284-.393-3.376-1.457-3.56-3.45a3.656 3.656 0 012.221-3.748 4.268 4.268 0 01-.45-1.6c-.211-2.27 1.485-4.005 4.205-4.258a5.856 5.856 0 013.683.586l.221 2.378-.323.246a4.692 4.692 0 00-3.14-.788c-1.264.117-1.903.673-1.836 1.401zm1.563 4.046a5.799 5.799 0 00-1.518-.075c-1.243.115-1.884.65-1.815 1.4.052.556.363.873 1.34 1.15a5.767 5.767 0 001.497.077c1.264-.118 1.905-.653 1.835-1.402-.053-.579-.363-.895-1.339-1.15z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16 3A13 13 0 113 16 13 13 0 0116 3m0-1a14 14 0 1014 14A14 14 0 0016 2z"
}));

var Icon = function Icon(_ref) {
  var desc = _ref.desc,
      _ref$focusable = _ref.focusable,
      focusable = _ref$focusable === void 0 ? false : _ref$focusable,
      title = _ref.title,
      iconName = _ref.iconName,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: String(focusable),
    className: classNames('rds-svg--paragraph-circle-icon', className)
  }, rest, svg.props), title && /*#__PURE__*/React.createElement("title", null, title), desc && /*#__PURE__*/React.createElement("desc", null, desc), svg.props.children);
};

Icon.propTypes = {
  desc: string,
  focusable: bool,
  title: string,
  iconName: string,
  className: string
};
Icon.displayName = 'ParagraphCircleIcon';
export default Icon;